import { render, staticRenderFns } from "./org-allocate-preview.vue?vue&type=template&id=97fd7b14&scoped=true"
import script from "./org-allocate-preview.vue?vue&type=script&lang=ts"
export * from "./org-allocate-preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fd7b14",
  null
  
)

export default component.exports